import React, { useEffect } from "react";
import { Field, useField } from "formik";
import { useAppSelector } from "app/hooks";
import { usePropagateRef } from "lib/hooks/usePropagateRefSingle";
import TextField from "@mui/material/TextField";

const FieldTextField = ({ name, label, margin, subSectionId, maxLength = 50, visible = true }: any) => {
  const [fieldValue, setFieldValue] = React.useState("");
  const [field, meta, helpers] = useField(name);
  const error = !!meta.error && meta.touched;

  const { answers } = useAppSelector((state) => state.survey) ?? [];
  const id = name.split(".")[2];
  const answer =
    answers.find((answer) => answer.questionID === id && answer.subSectionId === subSectionId)?.value ?? "";

  usePropagateRef({
    name,
    setFieldValue,
    value: field.value,
  });

  useEffect(() => {
    if (meta.touched) {
      return;
    }
    if (field.value !== fieldValue) {
      setFieldValue(field.value);
    }
  }, [field.value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(event.target.value);
  };

  const onBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    const val = evt.target.value || "";
    window.setTimeout(() => {
      field.onChange({
        target: {
          name: name,
          value: val,
        },
      });
    }, 0);
  };

  const performanceProps = {
    onFocus: onBlur,
  };

  useEffect(() => {
    if (answer) helpers.setValue(answer);
  }, [answer]);
  return visible ? (
    <Field
      as={TextField}
      fullWidth
      name={name}
      label={label}
      error={error}
      margin={margin}
      onBlur={onBlur}
      value={fieldValue}
      inputProps={{
        maxLength,
      }}
      onChange={handleChange}
      helperText={meta.touched && meta.error}
      {...performanceProps}
    />
  ) : null;
};

export default FieldTextField;
